"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIScoreSchemaV1 = void 0;
const zod_1 = require("zod");
const scores_1 = require("../../../../../domain/scores");
/**
 * Foundation schema for scores API v1 i.e. trace and observation scores ONLY
 *
 * Must be extended with score data specific schema (numeric, categorical, boolean, text)
 * @see {@link NumericData}, {@link CategoricalData}, {@link BooleanData}
 */
const ScoreFoundationSchemaV1 = scores_1.ScoreSchemaExclReferencesAndDates.extend({
    // Timestamps
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    timestamp: zod_1.z.coerce.date(),
    // Score references
    traceId: zod_1.z.string(),
    observationId: zod_1.z.string().nullish(),
});
// Response-only schema without input validation constraints (e.g. length limits)
const TextData = zod_1.z.object({
    stringValue: zod_1.z.string(),
    dataType: zod_1.z.literal("TEXT"),
});
exports.APIScoreSchemaV1 = zod_1.z.discriminatedUnion("dataType", [
    ScoreFoundationSchemaV1.extend(scores_1.NumericData.shape),
    ScoreFoundationSchemaV1.extend(scores_1.CategoricalData.shape),
    ScoreFoundationSchemaV1.extend(scores_1.BooleanData.shape),
    ScoreFoundationSchemaV1.omit({ value: true }).extend(TextData.shape),
]);
